import {FormFieldTypes} from "./enums";
import {EMAIL_VALIDATION_PATTERN} from "utils";

export const LoginFormModel = {
  fields:  [
    { id: "login", label: "Account name (e-mail)", type: FormFieldTypes.SHORT_STRING },
    { id: "password", label: "Password", type: FormFieldTypes.PASSWORD },
    { id: "rememberMe", label: "Remember Me", type: FormFieldTypes.CHECKBOX },
  ],
  validation: {
    login: {
      pattern: {value: EMAIL_VALIDATION_PATTERN, message: "Account name must be a valid e-mail address."},
      required: {value: true, message: "Account name cannot be empty."},
      maxLength: {value: 50, message: "Account name cannot be longer than 50 characters."},
    },
    password: {
      required: { value: true, message: "You must provide a value for Password."},
      maxLength: { value: 20, message: "You may provide at most 20 characters for Password." },
      minLength: { value: 6, message: "You must provide at least 6 characters for Password." },
    },
    rememberMe: {},
  }
};

export const LoginStartFormModel = {
  fields:  [
    { id: "login", label: "Enter your e-mail address", type: FormFieldTypes.SHORT_STRING },
  ],
  validation: {
    login: {
      pattern: {value: EMAIL_VALIDATION_PATTERN, message: "Account name must be a valid e-mail address."},
      required: {value: true, message: "Account name cannot be empty."},
      maxLength: {value: 100, message: "Account name cannot be longer than 100 characters."},
    },
  }
};

export const LoginPasswordFormModel = {
  fields:  [
    { id: "password", label: "Enter your Password", type: FormFieldTypes.PASSWORD },
    { id: "rememberMe", label: "Remember Me", type: FormFieldTypes.CHECKBOX },
  ],
  validation: {
    password: {
      required: { value: true, message: "You must provide a value for Password."},
      maxLength: { value: 20, message: "You may provide at most 20 characters for Password." },
      minLength: { value: 6, message: "You must provide at least 6 characters for Password." },
    },
    rememberMe: {},
  }
};

export const LinkPasswordFormModel = {
  fields:  [
    { id: "password", label: "Enter your Eledo Password", type: FormFieldTypes.PASSWORD },
    { id: "rememberMe", label: "Remember Me", type: FormFieldTypes.CHECKBOX },
  ],
  validation: {
    password: {
      required: { value: true, message: "You must provide a value for Password."},
      maxLength: { value: 20, message: "You may provide at most 20 characters for Password." },
      minLength: { value: 6, message: "You must provide at least 6 characters for Password." },
    },
    rememberMe: {},
  }
};

export const CreateAccountFormModel = {
  fields:  [
    { id: "signupTerms", label: (<>I have read and agree with Eledo's <a href="https://eledo.online/policies/terms" target="_blank">Terms and Conditions</a> and <a href="https://eledo.online/policies/cookies" target="_blank">Privacy and Cookies policy</a></>), type: FormFieldTypes.CHECKBOX },
    { id: "signupNewsletter", label: "I would like to receive emails about new features and news at Eledo.", type: FormFieldTypes.CHECKBOX },
  ],
  validation: {
    signupTerms: {
      required: { value: true, message: "Your consent is required to create new account."},
    },
    rememberMe: {},
  }
};